import ownerDetailsEditComponent from './owner-details-edit.component';

const ownerDetailsEditModule = angular.module('ownerDetailsEdit', [])
  .component('ownerDetailsEdit', ownerDetailsEditComponent)
  .name;

export default ownerDetailsEditModule;
